module.exports = __webpack_public_path__ + "img/img-en-usd.90138655.png";